export default function isEmptyHtmlField(field: string): boolean {
	return !!field && field !== '<div class="payload-richtext"></div>';
}
